import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { ROLE_OPTIONS } from './roleUtils';

// value: 'all' | '1' | '2' | '3' | '4'
// onChange: (value) => void
const RoleFilterSelect = ({ value, onChange }) => (
  <TextField
    select
    size="small"
    label="Rôle"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    sx={{
      minWidth: 170,
      '& .MuiOutlinedInput-root': { borderRadius: '12px' },
    }}
    SelectProps={{ MenuProps: { sx: { zIndex: 3000 } } }}
  >
    <MenuItem value="all">Tous les rôles</MenuItem>
    {ROLE_OPTIONS.map((role) => (
      <MenuItem key={role.value} value={role.value}>
        {role.label}
      </MenuItem>
    ))}
  </TextField>
);

export default RoleFilterSelect;
